import { render, staticRenderFns } from "./LimitRow.vue?vue&type=template&id=455c2201&"
import script from "./LimitRow.vue?vue&type=script&lang=js&"
export * from "./LimitRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports